/**
 * EventBus léger — pub/sub global pour déclencher les nudges (et autres événements app-wide).
 *
 * Usage :
 *   import eventBus from '../../utils/eventBus';
 *   eventBus.emit('library.book.created', { bookId: 42 });
 *   eventBus.on('library.book.created', (payload) => { ... });
 */

const listeners = new Map(); // Map<eventName, Set<handler>>

const eventBus = {
    on(event, handler) {
        if (!listeners.has(event)) listeners.set(event, new Set());
        listeners.get(event).add(handler);
        return () => this.off(event, handler);
    },

    off(event, handler) {
        const set = listeners.get(event);
        if (set) set.delete(handler);
    },

    emit(event, payload) {
        const set = listeners.get(event);
        if (!set) return;
        set.forEach(h => {
            try { h(payload); } catch (err) {
                console.error(`[eventBus] handler error for ${event}:`, err);
            }
        });
    }
};

export default eventBus;
